(function PotentialGroups($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Reports/potentialGroups', function onload()
		{
			$("a.info-link").on('click', function showInfo(e) {
				var start     = $(this).data("start"),
					end       = $(this).data("end"),
					ship_id   = $(this).data("ship-id"),
					ship      = $(this).data("ship-name");

				e.preventDefault();

				$modal.find('.modal-title').text("Reservations on " + ship);
				$modal.addClass('wide');

				$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading...');

				Adzuki.Ajax.get('/Reservations/potentialGroupReservations/' + start + '/' + end + '/' + ship_id)
				.then(function getReservationsTable(content) {
					$modal.find('.modal-body').html(content);
				});

				$modal.modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));
